export const STORAGE_THEME_KEY = "__THEME__";
